<template>
	<div>
		<div class="categories">
			<div>
				<input type="radio" id="categChoice1" name="category" value="1" v-model="computedCategory" data-hj-allow/>
				<label for="categChoice1">
					<img src="/img/frontend/category/ingatlan-ingosag.png" alt="Ingatlan+ingóság" />
					<span class="categ-name">Ingatlan + ingóság</span>
				</label>
			</div>

			<div>
				<input type="radio" id="categChoice3" name="category" value="2" v-model="computedCategory" data-hj-allow/>
				<label for="categChoice3">
					<img src="/img/frontend/category/ingatlan.png" alt="Ingatlan" />
					<span class="categ-name">Ingatlan</span>
				</label>
			</div>

            <div>
				<input type="radio" id="categChoice2" name="category" value="3" v-model="computedCategory" data-hj-allow/>
				<label for="categChoice2">
					<img src="/img/frontend/category/ingosag.png" alt="Ingóság" />
					<span class="categ-name">Ingóság</span>
				</label>
			</div>
		</div>
		<span class="error_message text-center d-flex justify-center w-100 mb-20px" v-if="error">{{ error }}</span>
		<button class="btn btn-blue" :class="{ disabled: computedCategory === null }" @click="handleStart">
			Kezdjük
		</button>
	</div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import DataLayer from '@/helpers/dataLayer.js';

export default {
	mounted() {
		if (this.findGetParameter('category')) {
			this.category = parseInt(this.findGetParameter('category'));
		}
	},
	data() {
		return {
			category: null,
			error: null,
		};
	},
	computed: {
		...mapGetters(['getCategory', 'getRealEstates']),
		...mapGetters('auth', ['isLoggedIn', 'isConsultant']),

		computedCategory: {
			get() {
				return this.getCategory !== null ? this.getCategory : this.category;
			},
			set(value) {
				this.category = parseInt(value);
			},
		},
	},
	methods: {
		...mapMutations(['setCurrentStep', 'setCategory', 'showPopup']),
		handleStart() {
			if (this.computedCategory === null) {
				this.error = 'Válasszon a fenti kategóriák közül.';
				return;
			}

			DataLayer.setEvent('dijkalkulacio_megkezdese');

			this.error = null;

			this.setCategory(this.category);
			this.setCurrentStep(1);

			if (this.isLoggedIn && this.getRealEstates.length > 0 && !this.isConsultant) {
				this.showPopup('RealEstateChooser');
			} else if (this.isConsultant) {
				this.showPopup('Consultant');
			} else {
                if (this.isItHomeInsuranceCampaign) {
                    this.setCurrentStep(2);
                    this.$router.push({ name: 'property-details' });
                }
                else {
                    this.$router.push({name: 'is-company'});
                }
			}
		},
		findGetParameter(parameterName) {
			let result = null,
				tmp = [];

			let items = location.search.substr(1).split('&');
			for (let index = 0; index < items.length; index++) {
				tmp = items[index].split('=');
				if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
			}
			return result;
		},
	},
};
</script>
